import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

export default function AccountRefreshNotice({ onClose, onLogin }) {
  const closeRef = useRef(null);
  const loginRef = useRef(null);

  useEffect(() => {
    const previousFocus = document.activeElement;
    loginRef.current?.focus();
    return () => previousFocus?.focus();
  }, []);

  const handleKeyDown = (event) => {
    if (event.key === 'Escape') onClose();
    if (event.key === 'Tab') {
      event.preventDefault();
      const target = document.activeElement === loginRef.current ? closeRef : loginRef;
      target.current?.focus();
    }
  };

  return createPortal(
    <div className="fixed inset-0 z-[10000] flex items-center justify-center bg-black/50 px-4">
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="account-refresh-title"
        aria-describedby="account-refresh-description"
        onKeyDown={handleKeyDown}
        className="responsive-dialog-panel w-full max-w-md rounded-2xl bg-white p-6 shadow-panel"
      >
        <h2 id="account-refresh-title" className="text-xl font-bold text-ink">请更新账户信息</h2>
        <p id="account-refresh-description" className="mt-3 text-sm leading-relaxed text-muted">
          您的账户信息已经太久没更新，请退出后重新登录，或直接重新登录。
        </p>
        <div className="mt-6 flex flex-wrap justify-end gap-3">
          <button ref={closeRef} type="button" onClick={onClose} className="rounded-xl border border-line px-4 py-2 text-sm text-ink hover:bg-canvas">
            稍后再说
          </button>
          <button ref={loginRef} type="button" onClick={onLogin} className="rounded-xl bg-brand px-4 py-2 text-sm font-semibold text-white hover:bg-brand-hover">
            重新登录
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
